<template>
  <v-container fluid class="home-feed-container">
    <div v-if="loading">
      <ul>
        <li>
          <PostContentLoader />
        </li>
        <li>
          <PostContentLoader />
        </li>
      </ul>
    </div>
    <div v-else>
      <div v-if="this.$store.getters.patient.isArchived">
        <p>{{ $t('text.availableUntil', this.$store.getters.patient ) }} {{ enabledUntil | moment("D MMMM YYYY") }}.</p>
        <p>{{ $t('text.canDownload', this.$store.getters.patient ) }}</p>
        <a class="linkified" href="/download">{{ $t('text.downloadDiary') }}</a>
      </div>
      <div v-if="posts.length > 0">
        <ul>
          <li v-for="post in posts" v-bind:key="post.id" :id="post.id">
            <Post
              :draft="post.isDraft"
              :post="post"
              :addedDictionaryEntries="post.dictionaryEntries"
              :checklist="post.checklists"
              v-on:post-like-success="getPosts"
              v-on:post-like-failed="this.consoleLog('like failed')"
              v-on:post-delete-success="redirect('/')"
              v-on:post-delete-failed="this.consoleLog('delete failed')"
              v-on:comment-delete-success="getPosts"
              v-on:comment-delete-failed="this.consoleLog('delete failed')"
              v-on:comment="postComment"
              v-on:comment-edit="editComment"
            ></Post>
          </li>
        </ul>
        <div
          v-if="!loading && hasMorePosts"
          ref="infiniteScrollSentinel"
          class="infinite-scroll-sentinel"
        ></div>
        <div v-if="loadingMore" class="infinite-scroll-loading">
          <PostContentLoader />
        </div>
        <div
          :class="[
            this.$store.getters.user.role === 'n' ? 'fab-no-tabs' : '',
            'fab-container'
          ]"
          v-if="this.$store.getters.user.role !== 'o'"
        >
          <Button
            class="fab"
            title
            color="#fff"
            bgcolor="#00A9B3"
            width="42px"
            height="42"
            margin="0"
            padding="0"
            icon="plus-white"
            @click.native="navigateBasedOnRole()"
          />
        </div>
      </div>
      <div v-else>
        <div class="display-message-container">
          <div class="display-message">
            <img
              :src="require('@/assets/images/duck-blue.svg')"
              alt="Duck icon"
            />
            <p class="pink--text" v-html="$t('general.post.not-found')"></p>
          </div>
        </div>
        <div
          :class="[
            this.$store.getters.user.role === 'n' ? 'fab-no-tabs' : '',
            'fab-container'
          ]"
          v-if="this.$store.getters.user.role !== 'o'"
        >
          <Button
            class="fab"
            title
            color="#fff"
            bgcolor="#00A9B3"
            width="42px"
            height="42"
            margin="0"
            padding="0"
            icon="plus-white"
            @click.native="navigateBasedOnRole()"
          />
        </div>
      </div>
    </div>

    <!-- <Tabbar v-if="$session.get('user').role !== 'n'" /> -->
    <!-- <NurseModal /> -->

    <!-- <v-btn
      fab
      color="secondary"
      fixed
      right
      bottom
      class="mb-15"
      href="/create/post"
    >
      <v-icon>➕</v-icon>
    </v-btn> -->
    <!-- <NurseModal /> -->
  </v-container>
</template>

<script>
import i18n from "@/services/i18n";
import { neoparentPosts } from "@/api";
import { getNotifications } from "@/helpers";
const marked = require('marked');

export default {
  i18n: i18n,
  name: "neoparent-home",
  props: ["enabled-until", "postId"],

  data() {
    return {
      loading: true,
      posts: [],
      nextSkip: 0,
      hasMorePosts: true,
      loadingMore: false,
      pageSize: 15,
      scrollObserver: null,
      highlightId: new URL(window.location).searchParams.get("highlight")
    };
  },
  mounted() {
    this.getPosts();
    // getNotifications();
    if (this.highlightId) {
      // Get post referred to
      let referredPost = document.getElementById(this.highlightId);
      console.log(this.highlightId);
      console.log(referredPost);

      // Scroll to post
      window.scroll(0, referredPost.offsetTop - "70");

      // Highlight post for 1 sec
      let originalBgColor = referredPost.firstChild.style.backgroundColor;
      referredPost.firstChild.style.backgroundColor = "rgba(224, 84, 132, 0.3)";
      setTimeout(function() {
        referredPost.firstChild.style.backgroundColor = originalBgColor;
      }, 1000);
    }
  },
  beforeDestroy() {
    this.teardownInfiniteScroll();
  },
  methods: {
    async getPosts() {
      this.teardownInfiniteScroll();
      this.loading = true;
      this.posts = [];
      this.nextSkip = 0;
      this.hasMorePosts = true;

      await this.loadNextPostBatch();

      this.$store.commit("clearPost");
      this.loading = false;

      this.$nextTick(() => {
        this.setupInfiniteScroll();
      });
    },
    async loadNextPostBatch() {
      if (!this.hasMorePosts || this.loadingMore) {
        return;
      }

      this.loadingMore = true;
      const minDelay = this.debugSlowLoadEnabled()
        ? new Promise(resolve => setTimeout(resolve, 3000))
        : Promise.resolve();

      try {
        const result = await neoparentPosts.getPostsForPatientPage(
          this.$store.getters.user.patient.id,
          this.nextSkip,
          this.pageSize
        );

        await minDelay;

        const fetchedPosts = result.data.posts || [];
        fetchedPosts.forEach(post => {
          if (!post.content) {
            post.content = "";
          }

          post.content = marked.parse(post.content);
        });

        this.posts = this.posts.concat(fetchedPosts);
        this.nextSkip = result.data.nextSkip || this.nextSkip;
        this.hasMorePosts = !!result.data.hasMore;
        if (!this.hasMorePosts) {
          this.teardownInfiniteScroll();
        }
      } catch (err) {
        this.consoleLog(err);
        this.hasMorePosts = false;
        this.teardownInfiniteScroll();
      } finally {
        this.loadingMore = false;
      }
    },
    debugSlowLoadEnabled() {
      return this.$store.getters.debugSlowLoad === true;
    },
    setupInfiniteScroll() {
      if (!this.hasMorePosts || this.scrollObserver) {
        return;
      }

      const sentinel = this.$refs.infiniteScrollSentinel;
      if (!sentinel) {
        return;
      }

      this.scrollObserver = new IntersectionObserver(async entries => {
        const entry = entries[0];
        if (!entry || !entry.isIntersecting) {
          return;
        }

        await this.loadNextPostBatch();
      }, {
        root: null,
        rootMargin: "350px 0px",
        threshold: 0.01
      });

      this.scrollObserver.observe(sentinel);
    },
    teardownInfiniteScroll() {
      if (this.scrollObserver) {
        this.scrollObserver.disconnect();
        this.scrollObserver = null;
      }
    },
    postComment({ postId, comment, callback }) {
      neoparentPosts
        .addCommentToPost(postId, {
          content: comment
        })
        .then(result => {
          this.consoleLog(result);
          this.getPosts();
          callback();
        })
        .catch(err => {
          this.consoleLog(err);
        });
    },
    editComment(data) {
      neoparentPosts
        .editComment(data.postId, data.commentId, {
          id: data.commentId,
          content: data.content
        })
        .then(result => {
          this.consoleLog(result);
          this.getPosts();
        })
        .catch(err => {
          this.consoleLog(err);
        });
    },
    navigateBasedOnRole: function() {
      if (this.$store.getters.user.role === "p") {
        window.location.href = "/create/post";
      } else {
        this.$modal.show("nurse-modal");
      }
    }
  }
};
</script>

<style scoped>
.home-feed-container {
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-bottom: 84px;
}

li:not(:last-child) {
  border-bottom: 3px solid #afdfd3;
}

li {
  min-width: 100%;
}

.tabcontainer {
  padding-bottom: 40px; /* To enable clicking actions when scrolled down */
}

.infinite-scroll-sentinel {
  height: 1px;
}

.infinite-scroll-loading {
  padding: 12px 0;
}

@media (hover: none) and (pointer: coarse) {
  .home-feed-container {
    padding-bottom: 94px;
  }
}
</style>
